import { render, staticRenderFns } from "./TheGroupModalEdit.vue?vue&type=template&id=13636424&scoped=true"
import script from "./TheGroupModalEdit.vue?vue&type=script&lang=js"
export * from "./TheGroupModalEdit.vue?vue&type=script&lang=js"
import style0 from "./TheGroupModalEdit.vue?vue&type=style&index=0&id=13636424&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13636424",
  null
  
)

export default component.exports